import script from "./ScreenAudioElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenAudioElement.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenAudioElement.vue?vue&type=style&index=0&id=1172b8ee&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1172b8ee"]])

export default __exports__